import React from "react";
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';
import {images} from "../../constant";
import {Helmet} from "react-helmet";
import {BASE_URL} from "../../helper";
import {Link, NavLink} from "react-router-dom";
import CommonStaticSidebar from "./commonStaticSidebar";


class Faq extends React.Component {

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <>
                <React.Fragment>

                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>Farmer's Fresh Meat - Frequently Asked Question</title>
                        <meta name="description" content="Farmer's Fresh Meat is proud to be the best butcher shop and meat market in Houston, Texas. Buy wholesale beef, goat meat, chicken, and more - on sale now!"/>
                        <meta name="robots" content="index, follow"/>
                        <meta name="googlebot" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"/>
                        <meta property="og:type" content="article"/>
                        <meta property="og:title" content="Farmer's Fresh Meat - Voted Best Meat Market/Butcher Shop in Houston"/>
                        <meta property="og:description" content="Farmer's Fresh Meat is proud to be the best butcher shop and meat market in Houston, Texas. Buy wholesale beef, goat meat, chicken, and more - on sale now!"/>
                        <meta property="og:url" content={BASE_URL() + this.props.location.pathname}/>
                        <meta property="og:site_name" content="Farmer&#039;s Fresh Meat: Houston Meat Market &amp; Butcher Shop"/>
                        <meta property="article:publisher" content="https://www.facebook.com/farmersfreshmeat"/>
                        <meta property="article:modified_time" content="2022-02-28T13:10:39+00:00"/>
                        <meta property="og:image" content={images.logoImg}/>
                        <meta property="og:image:width" content="1449"/>
                        <meta property="og:image:height" content="1024"/>
                        <meta name="twitter:card" content="summary"/>
                        <meta name="twitter:creator" content="Farmerfreshmeat"/>
                        <meta name="twitter:site" content="Farmerfreshmeat"/>
                        <link rel="canonical" href={BASE_URL() + this.props.location.pathname}/>
                        <script type="application/ld+json" className="yoast-schema-graph">{` {"@context":"https://schema.org","@graph":[{"@type":"Organization","@id":"https://farmersfreshmeat.com/#organization","name":"Farmer's Fresh Meat","url":"https://farmersfreshmeat.com/","sameAs":["https://www.facebook.com/farmersfreshmeat","https://www.instagram.com/farmersfreshmeat/","https://www.youtube.com/user/farmersfreshmeat","https://www.pinterest.com/Farmerfreshmeat/","https://twitter.com/Farmerfreshmeat"],"logo":{"@type":"ImageObject","@id":"https://farmersfreshmeat.com/#logo","inLanguage":"en-US","url":"https://farmersfreshmeat.com/wp-content/uploads/2015/03/Farmers_Fresh_Meat_Logo.png","width":312,"height":79,"caption":"Farmer's Fresh Meat"},"image":{"@id":"https://farmersfreshmeat.com/#logo"}},{"@type":"WebSite","@id":"https://farmersfreshmeat.com/#website","url":"https://farmersfreshmeat.com/","name":"Farmer&#039;s Fresh Meat: Houston Meat Market &amp; Butcher Shop","description":"Farmers Fresh Meat","publisher":{"@id":"https://farmersfreshmeat.com/#organization"},"potentialAction":[{"@type":"SearchAction","target":"https://farmersfreshmeat.com/?s={search_term_string}","query-input":"required name=search_term_string"}],"inLanguage":"en-US"},{"@type":"ImageObject","@id":"https://farmersfreshmeat.com/shop/leg-quarters/#primaryimage","inLanguage":"en-US","url":"https://farmersfreshmeat.com/wp-content/uploads/2019/09/Leg-Quarters-3-scaled.jpg","width":1449,"height":1024},{"@type":"WebPage","@id":"https://farmersfreshmeat.com/shop/leg-quarters/#webpage","url":"https://farmersfreshmeat.com/shop/leg-quarters/","name":"Fresh Chicken Leg Quarters By the Pound - On Sale now!","isPartOf":{"@id":"https://farmersfreshmeat.com/#website"},"primaryImageOfPage":{"@id":"https://farmersfreshmeat.com/shop/leg-quarters/#primaryimage"},"datePublished":"2019-09-23T15:14:32+00:00","dateModified":"2022-02-28T13:10:39+00:00","description":"Fresh Chicken Leg Quarters on Sale and Priced per pound. Hormone free and cut free of charge. The best price and quality at Farmer's Fresh Meat!","inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://farmersfreshmeat.com/shop/leg-quarters/"]}]}]}`}</script>
                    </Helmet>

                    <div className="about-banner">
                        <div className="image-wrap">
                            <div className="img-content">
                                <img
                                    src={images.about}
                                    alt="Not Found"
                                    className="img-fluid"
                                />
                            </div>
                            <div className="overlay"></div>
                        </div>
                        <div className="banner-content">
                            <h1>Frequently Asked Questions</h1>
                        </div>
                    </div>
                    <div className="container-fluid about-content mt-3 mb-fix">
                        <div className="col-12">
                            <div className="row">
                                <CommonStaticSidebar />
                                <div className="col-md-9">
                                <div className="category-faq">

                                    {/*<ul>*/}
                                    {/*    <li>*/}
                                    {/*        <a href="" className="">How do I create a new account?</a>*/}
                                    {/*    </li>*/}
                                    {/*    <li>*/}
                                    {/*        <a href="" className="">How to change account password?</a>*/}
                                    {/*    </li>*/}
                                    {/*    <li>*/}
                                    {/*        <a href="" className="">How do I create a new account?</a>*/}
                                    {/*    </li>*/}
                                    {/*    <li>*/}
                                    {/*        <a href="" className="">How to change account password?</a>*/}
                                    {/*    </li>*/}
                                    {/*    <li>*/}
                                    {/*        <a href="" className="">How do I create a new account?</a>*/}
                                    {/*    </li>*/}
                                    {/*    <li>*/}
                                    {/*        <a href="" className="">How to change account password?</a>*/}
                                    {/*    </li>*/}
                                    {/*    <li>*/}
                                    {/*        <a href="" className="">How do I create a new account?</a>*/}
                                    {/*    </li>*/}
                                    {/*    <li>*/}
                                    {/*        <a href="" className="">How to change account password?</a>*/}
                                    {/*    </li>*/}
                                    {/*</ul>*/}

                                    <ul>
                                        <li className="w-100 main-section bg-white">
                                            <Accordion allowZeroExpanded>
                                                <AccordionItem>
                                                    <AccordionItemHeading>
                                                        <AccordionItemButton>
                                                            Where is Farmer’s Fresh Meat located?
                                                        </AccordionItemButton>
                                                    </AccordionItemHeading>
                                                    <AccordionItemPanel>
                                                        <div className="col-12 px-0">
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <h2 className="text-black mb-1">Farmers Fresh Meat at Cullen</h2>
                                                                    <div className="hours-details p-0">
                                                                        <p>8630 Cullen Blvd<br/>
                                                                            Houston, TX 77051
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <h2 className="text-black mb-1">Farmers Fresh Meat at Mesa</h2>
                                                                    <div className="hours-details p-0">
                                                                        <p>9541 Mesa Dr.<br/>
                                                                            Houston, TX 77078
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 text-center">
                                                                    <hr/>
                                                                    <p className="text-center">Have any questions? <NavLink exact to="/locations-contact" className="more-info">Click here to contact us.</NavLink></p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </AccordionItemPanel>
                                                </AccordionItem>
                                            </Accordion>
                                        </li>
                                        <li className="w-100 main-section bg-white">
                                            <Accordion allowZeroExpanded>
                                                <AccordionItem>
                                                    <AccordionItemHeading>
                                                        <AccordionItemButton>
                                                            How do I contact Farmer’s Fresh Meat?
                                                        </AccordionItemButton>
                                                    </AccordionItemHeading>
                                                    <AccordionItemPanel>
                                                        <p className="mb-2">
                                                            Get in touch with us for your queries.
                                                        </p>
                                                        <p className="mb-1">
                                                            Call at:- <a href="tel:7137155051" className="font-weight-medium more-info">(713) 715-5051</a>
                                                        </p>
                                                        <p>
                                                            Email at:- <a href="mailto:contact@farmersfreshmeat.com" className="font-weight-medium more-info">Contact@farmersfreshmeat.com</a>
                                                        </p>
                                                    </AccordionItemPanel>
                                                </AccordionItem>
                                            </Accordion>
                                        </li>
                                        <li className="w-100 main-section bg-white">
                                            <Accordion allowZeroExpanded>
                                                <AccordionItem>
                                                    <AccordionItemHeading>
                                                        <AccordionItemButton>
                                                            Do the meat packs come with some of the free items or all of them?
                                                        </AccordionItemButton>
                                                    </AccordionItemHeading>
                                                    <AccordionItemPanel>
                                                        <p>
                                                            The Free Items listed with each Meat Pack include ALL of those items!
                                                        </p>
                                                    </AccordionItemPanel>
                                                </AccordionItem>
                                            </Accordion>
                                        </li>
                                        <li className="w-100 main-section bg-white">
                                            <Accordion allowZeroExpanded>
                                                <AccordionItem>
                                                    <AccordionItemHeading>
                                                        <AccordionItemButton>
                                                            Can you substitute an item in a meat pack if I don’t want something?
                                                        </AccordionItemButton>
                                                    </AccordionItemHeading>
                                                    <AccordionItemPanel>
                                                        <p>
                                                            Yes. If there is an item or two you do not want, you can substitute it and get it’s value for anything else we carry.
                                                        </p>
                                                    </AccordionItemPanel>
                                                </AccordionItem>
                                            </Accordion>
                                        </li>
                                        <li className="w-100 main-section bg-white">
                                            <Accordion allowZeroExpanded>
                                                <AccordionItem>
                                                    <AccordionItemHeading>
                                                        <AccordionItemButton>
                                                            If I bring my own meat in, can you guys cut it for me?
                                                        </AccordionItemButton>
                                                    </AccordionItemHeading>
                                                    <AccordionItemPanel>
                                                        <p>
                                                            Yes. For cutting on the band saw, we only charge .50c/lb. If you want additional processing like pan sausage grinding, and sausage links, we charge $1.25/lb.
                                                        </p>
                                                    </AccordionItemPanel>
                                                </AccordionItem>
                                            </Accordion>
                                        </li>
                                        <li className="w-100 main-section bg-white">
                                            <Accordion allowZeroExpanded>
                                                <AccordionItem>
                                                    <AccordionItemHeading>
                                                        <AccordionItemButton>
                                                            Do you process Deer?
                                                        </AccordionItemButton>
                                                    </AccordionItemHeading>
                                                    <AccordionItemPanel>
                                                        <p>
                                                            You bet! We process deer and other wild game like Hog. Bring it in a cooled state and we will take care of the rest from chops to pan sausage to links we will do whatever you want done. We will also season it with our all natural green onion and garlic seasonings.
                                                        </p>
                                                    </AccordionItemPanel>
                                                </AccordionItem>
                                            </Accordion>
                                        </li>
                                        <li className="w-100 main-section bg-white">
                                            <Accordion allowZeroExpanded>
                                                <AccordionItem>
                                                    <AccordionItemHeading>
                                                        <AccordionItemButton>
                                                            Do you cater events?
                                                        </AccordionItemButton>
                                                    </AccordionItemHeading>
                                                    <AccordionItemPanel>
                                                        <p>
                                                            Unfortunately we do not currently cater, BUT we do the next best thing. We can cook any item you desire for your event and you will have to come in store and pick it up or it can be delivered to you for a fee. Please contact a manager for pricing.
                                                        </p>
                                                    </AccordionItemPanel>
                                                </AccordionItem>
                                            </Accordion>
                                        </li>
                                        <li className="w-100 main-section bg-white">
                                            <Accordion allowZeroExpanded>
                                                <AccordionItem>
                                                    <AccordionItemHeading>
                                                        <AccordionItemButton>
                                                            Where can I find employment opportunities?
                                                        </AccordionItemButton>
                                                    </AccordionItemHeading>
                                                    <AccordionItemPanel>
                                                        <p>
                                                            We are always looking to grow our team with hardworking, customer-focused individuals. If you think you’d be a great addition, please fill out this application form: <a className="more-info" href="/about/employment">Farmer's Career form.</a>
                                                        </p>
                                                    </AccordionItemPanel>
                                                </AccordionItem>
                                            </Accordion>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </React.Fragment>
            </>
        );
    }
}

export default Faq;



